var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FECDCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 23.3347V28.0014M27.9999 32.668H28.0116M26.0049 17.338L16.1232 33.8347C15.9195 34.1875 15.8117 34.5876 15.8106 34.995C15.8094 35.4024 15.915 35.803 16.1167 36.157C16.3185 36.511 16.6094 36.8059 16.9606 37.0125C17.3117 37.2192 17.7108 37.3302 18.1182 37.3347H37.8816C38.289 37.3302 38.6881 37.2192 39.0392 37.0125C39.3904 36.8059 39.6813 36.511 39.8831 36.157C40.0848 35.803 40.1904 35.4024 40.1892 34.995C40.1881 34.5876 40.0803 34.1875 39.8766 33.8347L29.9949 17.338C29.7869 16.9952 29.4941 16.7117 29.1446 16.5149C28.7952 16.3182 28.4009 16.2148 27.9999 16.2148C27.5989 16.2148 27.2046 16.3182 26.8552 16.5149C26.5057 16.7117 26.2129 16.9952 26.0049 17.338Z",
    stroke: "#B42318",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featured icon.42009ffcafbadfee8d2c8d447856a3db.svg";
export { ForwardRef as ReactComponent };